(function ($) {
    $.fn.eAjaxSpin = function (options) {
        var settings = $.extend({
            'text': '',
            'opacity': '0.5',
            'backgroundColor': '000000'
        }, options);
        return this.each(function () {
            var $this = $(this);
            $this.append($('<div></div>').addClass('ajax-overlay'));

            $('.ajax-overlay')
                        .css('width', '100%')
                        .css('height', '100%')
                        .css('position', 'fixed')
                        .css('top', $this.position()["top"])
                        .css('left', $this.position()["left"])
                        .css('z-index', '9999999')
                        .css('background-color', '#' + settings.backgroundColor)
                        .css('background-color', 'rgba(' + parseInt(settings.backgroundColor.substring(0, 2), 16) + ',' + parseInt(settings.backgroundColor.substring(2, 4), 16) + ',' + parseInt(settings.backgroundColor.substring(4, 6), 16) + ',' + settings.opacity + ')');
            $('.ajax-overlay').append($('<div></div>').addClass('ajax-spinner'));

            $('.ajax-spinner').css('position', 'absolute')
                        .css('height', '57px')
                        .css('width', '150px')
                        .css('top', '50%')
                        .css('left', '0')
                        .css('right', '0')
                        .css('margin', '0 auto')
                        .css('margin-top', '-70px');
            $('.ajax-spinner').append($('<div></div>').addClass('ajax-spinner-text'));

            $('.ajax-spinner-text').css('text-align', 'center')
                                   .css('margin-top', '30px')
                                   .css('color', '#333')
                                   .text();
        });
    };
    $.fn.eAjaxSpinRemove = function () {
        return this.each(function () {
            $(this).find('.ajax-overlay').remove();
        });
    };
})(jQuery);